import { Outlet } from "react-router-dom";
export default function Index() {
  return (
    <div> adminlayout1111
      <Outlet />
    </div>
  );
}